import { PageLoader } from '@american-autonomy/rantizo-ui';

import HorizontalGridContainer from 'components/containers/HorizontalGridContainer';

import useData from './hooks/useData';

import { STRIPE_PRICING_TABLE_PUBLISHABLE_KEY, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const StripePricingTable: FunctionComponent<Props> = ({ pricingTableId, testId = TEST_ID }) => {
    const { customerSessionSecret, pricingTableId: sessionPricingTableId } = useData();

    const resolvedPricingTableId = sessionPricingTableId ?? pricingTableId;

    return (
        <HorizontalGridContainer testId={testId}>
            {customerSessionSecret && resolvedPricingTableId ? (
                // @ts-expect-error - Custom Stripe element not recognized by TypeScript
                <stripe-pricing-table
                    customer-session-client-secret={customerSessionSecret}
                    pricing-table-id={resolvedPricingTableId}
                    publishable-key={STRIPE_PRICING_TABLE_PUBLISHABLE_KEY}
                    // @ts-expect-error - Custom Stripe element not recognized by TypeScript
                ></stripe-pricing-table>
            ) : (
                <PageLoader />
            )}
        </HorizontalGridContainer>
    );
};

export default StripePricingTable;
